import { useCallback, ReactNode } from 'react';
import { Icon } from '@octano/global-ui';

type StudentsRemovalRequestFormFileChipProps<T = unknown> = {
  value: T;
  size?: 'md' | 'sm';
  children: ReactNode;
  onRemove?: (value: T) => void;
};

export const StudentsRemovalRequestFormFileChip = <T,>({
  value,
  children,
  onRemove,
}: StudentsRemovalRequestFormFileChipProps<T>) => {
  const handleRemove = useCallback(() => {
    if (!onRemove) {
      return;
    }
    onRemove(value);
  }, [value, onRemove]);

  return (
    <button
      type="button"
      className={`btn btn-outline-primary`}
      disabled={!onRemove}
      onClick={onRemove ? handleRemove : undefined}
    >
      {children}

      {!!onRemove && <Icon name="close" size={12} className="ml-3" />}
    </button>
  );
};
